// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const Permissions = {
	AavoAi: {
		USE: "aavo_ai:use",
		USE_CHAT: "aavo_ai:use_chat",
		WEB_ACCESS: "aavo_ai:web_access",
		Icons: {
			SEARCH: "icons:search",
		},
		ProblemReports: {
			SEND: "problem_report:send",
		},
		UserEmail: {
			SEND: "user_email:send",
		},
		UserInbox: {
			SEND_MESSAGE: "user_inbox:send_message",
		},
	},
	Administration: {
		AiSettings: {
			MANAGE: "ai_settings:manage",
		},
		AiUsage: {
			READ: "ai_usage:read",
		},
		ApiConnectionLogs: {
			READ: "api_connection_logs:read",
		},
		ApiConnections: {
			MANAGE: "api_connections:manage",
			READ: "api_connections:read",
			USE: "api_connections:use",
		},
		ApiKeys: {
			MANAGE: "api_keys:manage",
		},
		Diagnostics: {
			READ_SENTRY_EVENTS: "diagnostics:read_sentry_events",
		},
		UserGroups: {
			MANAGE: "user_groups:manage",
			READ: "user_groups:read",
		},
		Users: {
			MANAGE: "users:manage",
			READ: "users:read",
		},
	},
	Common: {
		BASIC_ACCESS: "common:basic_access",
		AccountingMasterData: {
			MANAGE: "accounting_master_data:manage",
			READ: "accounting_master_data:read",
		},
		AttributeFields: {
			MANAGE: "attribute_fields:manage",
			READ: "attribute_fields:read",
		},
		BiDashboards: {
			READ: "bi_dashboards:read",
		},
		CommonMasterData: {
			MANAGE: "common_master_data:manage",
			READ: "common_master_data:read",
		},
		CostEventMasterData: {
			MANAGE: "cost_event_master_data:manage",
			READ: "cost_event_master_data:read",
		},
		CostEvents: {
			MANAGE: "cost_events:manage",
			READ: "cost_events:read",
		},
		DeviceLocation: {
			USE: "device_location:use",
		},
		EmailLog: {
			READ: "email_log:read",
		},
		EmailTemplates: {
			MANAGE: "email_templates:manage",
			READ: "email_templates:read",
		},
		ExternalEmail: {
			SEND: "external_email:send",
		},
		GoogleMaps: {
			USE: "google_maps:use",
		},
		IntegrationSettings: {
			MANAGE: "integration_settings:manage",
			READ: "integration_settings:read",
		},
		ManufacturingSystemDiagrams: {
			READ: "manufacturing_system_diagrams:read",
		},
		NotificationRules: {
			MANAGE: "notification_rules:manage",
			READ: "notification_rules:read",
		},
		ObjectChangeLog: {
			READ: "object_change_log:read",
		},
		RouteOptimization: {
			USE: "route_optimization:use",
		},
		SalesSystemDiagrams: {
			READ: "sales_system_diagrams:read",
		},
		ScheduledJobs: {
			RUN: "scheduled_jobs:run",
		},
		SpcSystemDiagrams: {
			READ: "spc_system_diagrams:read",
		},
		SystemDiagrams: {
			MANAGE: "system_diagrams:manage",
		},
	},
	CustomApps: {
		ASSIGN_EXECUTION_USER: "custom_apps:assign_execution_user",
		CREATE_ORGANIZATIONAL: "custom_apps:create_organizational",
		MANAGE: "custom_apps:manage",
		MANAGE_ALL: "custom_apps:manage_all",
		READ: "custom_apps:read",
		READ_SOURCES: "custom_apps:read_sources",
		USE: "custom_apps:use",
	},
	CustomFunctions: {
		ASSIGN_EXECUTION_USER: "custom_functions:assign_execution_user",
		CREATE_ORGANIZATIONAL: "custom_functions:create_organizational",
		EXECUTE: "custom_functions:execute",
		MANAGE: "custom_functions:manage",
		MANAGE_ALL: "custom_functions:manage_all",
		READ: "custom_functions:read",
		TEST: "custom_functions:test",
	},
	Delivery: {
		Deliveries: {
			LOAD: "deliveries:load",
			MANAGE: "deliveries:manage",
			READ: "deliveries:read",
		},
		DeliveryMasterData: {
			MANAGE: "delivery_master_data:manage",
			READ: "delivery_master_data:read",
		},
		DeliveryPackages: {
			MANAGE: "delivery_packages:manage",
			READ: "delivery_packages:read",
			SET_WAREHOUSE_LOCATION: "delivery_packages:set_warehouse_location",
		},
		DeliveryTransports: {
			DRIVE: "delivery_transports:drive",
			MANAGE: "delivery_transports:manage",
			PLAN: "delivery_transports:plan",
			READ: "delivery_transports:read",
		},
	},
	Documents: {
		DELETE: "documents:delete",
		LINK_EXISTING: "documents:link_existing",
		MANAGE: "documents:manage",
		READ: "documents:read",
		SEND: "documents:send",
		DocumentMasterData: {
			MANAGE: "document_master_data:manage",
			READ: "document_master_data:read",
		},
		DocumentTemplates: {
			MANAGE: "document_templates:manage",
			READ: "document_templates:read",
		},
		Wopi: {
			ACCESS: "wopi:access",
		},
	},
	Parts: {
		CatalogParts: {
			MANAGE: "catalog_parts:manage",
			READ: "catalog_parts:read",
		},
		ConfiguratorLogs: {
			READ: "configurator_logs:read",
		},
		Configurators: {
			MANAGE: "configurators:manage",
			READ: "configurators:read",
			TEST: "configurators:test",
		},
		PartConfigurations: {
			CONFIGURE: "part_configurations:configure",
			MANAGE: "part_configurations:manage",
			READ: "part_configurations:read",
			READ_CONFIGURATOR: "part_configurations:read_configurator",
		},
		PartMasterData: {
			MANAGE: "part_master_data:manage",
			READ: "part_master_data:read",
		},
		PartWarehouseLocations: {
			READ: "part_warehouse_locations:read",
		},
		SiteParts: {
			MANAGE: "site_parts:manage",
			READ: "site_parts:read",
		},
	},
	ProductChanges: {
		MANAGE: "product_changes:manage",
		READ: "product_changes:read",
		ProductChangeMasterData: {
			MANAGE: "product_change_master_data:manage",
			READ: "product_change_master_data:read",
		},
		ProductChangeRequests: {
			MANAGE: "product_change_requests:manage",
			MANAGE_ALL: "product_change_requests:manage_all",
			READ: "product_change_requests:read",
			READ_ALL: "product_change_requests:read_all",
		},
	},
	Production: {
		ProductionMasterData: {
			MANAGE: "production_master_data:manage",
			READ: "production_master_data:read",
		},
		ProductionReports: {
			READ: "production_reports:read",
		},
		ProductionStatus: {
			READ: "production_status:read",
		},
		ShopOrderBatches: {
			MANAGE: "shop_order_batches:manage",
			READ: "shop_order_batches:read",
		},
		ShopOrders: {
			MANAGE: "shop_orders:manage",
			MANAGE_SUPPLEMENTARY: "shop_orders:manage_supplementary",
			MOVE_ON_PRODUCTION_LINE: "shop_orders:move_on_production_line",
			PICK: "shop_orders:pick",
			READ: "shop_orders:read",
			RELEASE: "shop_orders:release",
			REPORT_PRODUCTION: "shop_orders:report_production",
			SCHEDULE: "shop_orders:schedule",
			SET_PRODUCTION_LINE: "shop_orders:set_production_line",
		},
		SubcontractingOperations: {
			MANAGE: "subcontracting_operations:manage",
		},
	},
	Projects: {
		EXTERNAL_ACTIVITY_JOB_QUEUE_USER: "project:activity_job_queue:external_user",
		MANAGE: "projects:manage",
		PICK: "projects:pick",
		READ: "projects:read",
		REPORT_PROGRESS: "projects:report_progress",
		SCHEDULE_ACTIVITIES: "projects:schedule_activities",
		ProjectMasterData: {
			MANAGE: "project_master_data:manage",
			READ: "project_master_data:read",
		},
		ProjectMaterials: {
			MANAGE: "project_materials:manage",
			READ: "project_materials:read",
			RELEASE: "project_materials:release",
		},
	},
	Purchasing: {
		PurchaseContracts: {
			MANAGE: "purchase_contracts:manage",
			READ: "purchase_contracts:read",
		},
		PurchaseMasterData: {
			MANAGE: "purchase_master_data:manage",
			READ: "purchase_master_data:read",
		},
		PurchaseOrders: {
			MANAGE: "purchase_orders:manage",
			READ: "purchase_orders:read",
			RECEIVE: "purchase_orders:receive",
			SUBMIT_SUPPLIER_DOCUMENTS: "purchase_orders:submit_supplier_documents",
		},
		PurchaseRequests: {
			MANAGE: "purchase_requests:manage",
			READ: "purchase_requests:read",
		},
		Suppliers: {
			MANAGE: "suppliers:manage",
			READ: "suppliers:read",
		},
	},
	Reclamations: {
		MANAGE: "reclamations:manage",
		READ: "reclamations:read",
		REPORT_PROGRESS: "reclamations:report_progress",
		ReclamationMasterData: {
			MANAGE: "reclamation_master_data:manage",
			READ: "reclamation_master_data:read",
		},
	},
	SafetyControlSurveys: {
		MANAGE: "safety_control_surveys:manage",
		READ: "safety_control_surveys:read",
		SafetyControlMasterData: {
			MANAGE: "safety_control_master_data:manage",
			READ: "safety_control_master_data:read",
		},
	},
	Sales: {
		CrmMasterData: {
			MANAGE: "crm_master_data:manage",
			READ: "crm_master_data:read",
		},
		CustomerOfferCommissions: {
			MANAGE: "customer_offer_commissions:manage",
			READ: "customer_offer_commissions:read",
		},
		CustomerOffers: {
			COMPLETE_SIGNING: "customer_offers:complete_signing",
			MANAGE: "customer_offers:manage",
			MANAGE_ALL: "customer_offers:manage_all",
			MANAGE_AS_INVOKER: "customer_offers:manage_as_invoker",
			READ: "customer_offers:read",
			READ_ALL: "customer_offers:read_all",
			READ_AS_INVOKER: "customer_offers:read_as_invoker",
			READ_COSTS: "customer_offers:read_costs",
		},
		CustomerOrderCommissions: {
			MANAGE: "customer_order_commissions:manage",
			READ: "customer_order_commissions:read",
		},
		CustomerOrders: {
			MANAGE: "customer_orders:manage",
			PICK: "customer_orders:pick",
			READ: "customer_orders:read",
			READ_INFO: "customer_orders:read_info",
		},
		Customers: {
			MANAGE: "customers:manage",
			MANAGE_ALL: "customers:manage_all",
			MANAGE_AS_INVOKER: "customers:manage_as_invoker",
			READ: "customers:read",
			READ_ALL: "customers:read_all",
			READ_AS_INVOKER: "customers:read_as_invoker",
		},
		Invoices: {
			MANAGE: "invoices:manage",
			READ: "invoices:read",
		},
		SalesActivities: {
			MANAGE: "sales_activities:manage",
			MANAGE_ALL: "sales_activities:manage_all",
			READ: "sales_activities:read",
			READ_ALL: "sales_activities:read_all",
		},
		SalesCommissionPayments: {
			MANAGE: "sales_commission_payments:manage",
			READ: "sales_commission_payments:read",
		},
		SalesContracts: {
			MANAGE: "sales_contracts:manage",
			READ: "sales_contracts:read",
		},
		SalesLeads: {
			ALLOCATE: "sales_leads:allocate",
			MANAGE: "sales_leads:manage",
			MANAGE_ALL: "sales_leads:manage_all",
			READ: "sales_leads:read",
			READ_ALL: "sales_leads:read_all",
		},
		SalesMasterData: {
			MANAGE: "sales_master_data:manage",
			READ: "sales_master_data:read",
		},
		SalesParts: {
			MANAGE: "sales_parts:manage",
			READ: "sales_parts:read",
		},
		SalesPriceLists: {
			MANAGE: "sales_price_lists:manage",
			READ: "sales_price_lists:read",
		},
	},
	Spc: {
		ControlChartCollections: {
			MANAGE: "spc_control_chart_collections:manage",
			READ: "spc_control_chart_collections:read",
		},
		ControlCharts: {
			CALCULATE_LIMITS: "spc_control_charts:calculate_limits",
			READ: "spc_control_charts:read",
		},
		DefectEvents: {
			READ: "spc_defect_events:read",
			RECORD: "spc_defect_events:record",
		},
		Measurements: {
			MANAGE: "spc_measurements:manage",
			RECORD: "spc_measurements:record",
			RECORD_TIME: "spc_measurements:record_time",
		},
		PerformanceCharts: {
			READ: "spc_performance_charts:read",
		},
		ProcessDiagrams: {
			READ: "spc_process_diagrams:read",
		},
		ProcessImprovements: {
			MANAGE: "spc_process_improvements:manage",
			READ: "spc_process_improvements:read",
		},
		Resources: {
			SET_STATE: "spc_resources:set_state",
		},
		SpcMasterData: {
			MANAGE: "spc_master_data:manage",
			READ: "spc_master_data:read",
		},
		SummaryViews: {
			READ: "spc_summary_views:read",
		},
	},
	Surveys: {
		SurveyForms: {
			MANAGE: "survey_forms:manage",
			READ: "survey_forms:read",
		},
		SurveySubmissions: {
			AUDIT: "survey_submissions:audit",
			READ: "survey_submissions:read",
			SUBMIT: "survey_submissions:submit",
		},
	},
	Tasks: {
		MANAGE: "tasks:manage",
		MANAGE_ALL: "tasks:manage_all",
		READ: "tasks:read",
		READ_ALL: "tasks:read_all",
		TaskTemplates: {
			MANAGE: "task_templates:manage",
			READ: "task_templates:read",
		},
	},
	Tenants: {
		Mellano: {
			LuukkuMetrics: {
				READ: "mellano_luukku_metrics:read",
			},
			LuukkuPlanning: {
				MANAGE: "mellano_luukku_planning:manage",
			},
			LuukkuProduction: {
				MANAGE: "mellano_luukku_production:manage",
				READ: "mellano_luukku_production:read",
			},
			LuukkuPurchaseOrders: {
				IMPORT: "mellano_luukku_purchase_orders:import",
			},
			LuukkuPurchaseSuggestions: {
				CREATE: "mellano_luukku_purchase_suggestions:create",
			},
			ProductionTools: {
				USE: "mellano_production_tools:use",
			},
			WinnerDesigns: {
				MANAGE: "mellano_winner_designs:manage",
				UPLOAD: "mellano_winner_designs:upload",
			},
		},
		Omegakeittiot: {
			IntraOrders: {
				CREATE: "omegakeittiot_intra_orders:create",
			},
		},
		Salvos: {
			CommissionLimits: {
				MANAGE: "salvos_commission_limits:manage",
				READ: "salvos_commission_limits:read",
			},
			OfferCommissions: {
				CALCULATE: "salvos_offer_commissions:calculate",
			},
			TransportActivities: {
				MANAGE: "salvos_transport_activities:manage",
			},
		},
	},
	Warehouse: {
		Inventory: {
			MANAGE: "inventory:manage",
			READ: "inventory:read",
		},
		ReplenishmentRequests: {
			MANAGE: "replenishment_requests:manage",
			READ: "replenishment_requests:read",
		},
		StockCounts: {
			MANAGE: "stock_counts:manage",
			READ: "stock_counts:read",
		},
		WarehouseLocations: {
			MANAGE: "warehouse_locations:manage",
			READ: "warehouse_locations:read",
		},
		WarehouseMasterData: {
			MANAGE: "warehouse_master_data:manage",
			READ: "warehouse_master_data:read",
		},
		WarehouseTransfers: {
			MANAGE: "warehouse_transfers:manage",
			READ: "warehouse_transfers:read",
		},
	},
	Workspaces: {
		MANAGE: "workspaces:manage",
		READ: "workspaces:read",
		WorkspaceMasterData: {
			MANAGE: "workspace_master_data:manage",
			READ: "workspace_master_data:read",
		},
	},
} as const;

export const PermissionValues = [
	"aavo_ai:use",
	"aavo_ai:use_chat",
	"aavo_ai:web_access",
	"accounting_master_data:manage",
	"accounting_master_data:read",
	"ai_settings:manage",
	"ai_usage:read",
	"api_connection_logs:read",
	"api_connections:manage",
	"api_connections:read",
	"api_connections:use",
	"api_keys:manage",
	"attribute_fields:manage",
	"attribute_fields:read",
	"bi_dashboards:read",
	"catalog_parts:manage",
	"catalog_parts:read",
	"common:basic_access",
	"common_master_data:manage",
	"common_master_data:read",
	"configurator_logs:read",
	"configurators:manage",
	"configurators:read",
	"configurators:test",
	"cost_event_master_data:manage",
	"cost_event_master_data:read",
	"cost_events:manage",
	"cost_events:read",
	"crm_master_data:manage",
	"crm_master_data:read",
	"custom_apps:assign_execution_user",
	"custom_apps:create_organizational",
	"custom_apps:manage",
	"custom_apps:manage_all",
	"custom_apps:read",
	"custom_apps:read_sources",
	"custom_apps:use",
	"custom_functions:assign_execution_user",
	"custom_functions:create_organizational",
	"custom_functions:execute",
	"custom_functions:manage",
	"custom_functions:manage_all",
	"custom_functions:read",
	"custom_functions:test",
	"customer_offer_commissions:manage",
	"customer_offer_commissions:read",
	"customer_offers:complete_signing",
	"customer_offers:manage",
	"customer_offers:manage_all",
	"customer_offers:manage_as_invoker",
	"customer_offers:read",
	"customer_offers:read_all",
	"customer_offers:read_as_invoker",
	"customer_offers:read_costs",
	"customer_order_commissions:manage",
	"customer_order_commissions:read",
	"customer_orders:manage",
	"customer_orders:pick",
	"customer_orders:read",
	"customer_orders:read_info",
	"customers:manage",
	"customers:manage_all",
	"customers:manage_as_invoker",
	"customers:read",
	"customers:read_all",
	"customers:read_as_invoker",
	"deliveries:load",
	"deliveries:manage",
	"deliveries:read",
	"delivery_master_data:manage",
	"delivery_master_data:read",
	"delivery_packages:manage",
	"delivery_packages:read",
	"delivery_packages:set_warehouse_location",
	"delivery_transports:drive",
	"delivery_transports:manage",
	"delivery_transports:plan",
	"delivery_transports:read",
	"device_location:use",
	"diagnostics:read_sentry_events",
	"document_master_data:manage",
	"document_master_data:read",
	"document_templates:manage",
	"document_templates:read",
	"documents:delete",
	"documents:link_existing",
	"documents:manage",
	"documents:read",
	"documents:send",
	"email_log:read",
	"email_templates:manage",
	"email_templates:read",
	"external_email:send",
	"google_maps:use",
	"icons:search",
	"integration_settings:manage",
	"integration_settings:read",
	"inventory:manage",
	"inventory:read",
	"invoices:manage",
	"invoices:read",
	"manufacturing_system_diagrams:read",
	"mellano_luukku_metrics:read",
	"mellano_luukku_planning:manage",
	"mellano_luukku_production:manage",
	"mellano_luukku_production:read",
	"mellano_luukku_purchase_orders:import",
	"mellano_luukku_purchase_suggestions:create",
	"mellano_production_tools:use",
	"mellano_winner_designs:manage",
	"mellano_winner_designs:upload",
	"notification_rules:manage",
	"notification_rules:read",
	"object_change_log:read",
	"omegakeittiot_intra_orders:create",
	"part_configurations:configure",
	"part_configurations:manage",
	"part_configurations:read",
	"part_configurations:read_configurator",
	"part_master_data:manage",
	"part_master_data:read",
	"part_warehouse_locations:read",
	"problem_report:send",
	"product_change_master_data:manage",
	"product_change_master_data:read",
	"product_change_requests:manage",
	"product_change_requests:manage_all",
	"product_change_requests:read",
	"product_change_requests:read_all",
	"product_changes:manage",
	"product_changes:read",
	"production_master_data:manage",
	"production_master_data:read",
	"production_reports:read",
	"production_status:read",
	"project:activity_job_queue:external_user",
	"project_master_data:manage",
	"project_master_data:read",
	"project_materials:manage",
	"project_materials:read",
	"project_materials:release",
	"projects:manage",
	"projects:pick",
	"projects:read",
	"projects:report_progress",
	"projects:schedule_activities",
	"purchase_contracts:manage",
	"purchase_contracts:read",
	"purchase_master_data:manage",
	"purchase_master_data:read",
	"purchase_orders:manage",
	"purchase_orders:read",
	"purchase_orders:receive",
	"purchase_orders:submit_supplier_documents",
	"purchase_requests:manage",
	"purchase_requests:read",
	"reclamation_master_data:manage",
	"reclamation_master_data:read",
	"reclamations:manage",
	"reclamations:read",
	"reclamations:report_progress",
	"replenishment_requests:manage",
	"replenishment_requests:read",
	"route_optimization:use",
	"safety_control_master_data:manage",
	"safety_control_master_data:read",
	"safety_control_surveys:manage",
	"safety_control_surveys:read",
	"sales_activities:manage",
	"sales_activities:manage_all",
	"sales_activities:read",
	"sales_activities:read_all",
	"sales_commission_payments:manage",
	"sales_commission_payments:read",
	"sales_contracts:manage",
	"sales_contracts:read",
	"sales_leads:allocate",
	"sales_leads:manage",
	"sales_leads:manage_all",
	"sales_leads:read",
	"sales_leads:read_all",
	"sales_master_data:manage",
	"sales_master_data:read",
	"sales_parts:manage",
	"sales_parts:read",
	"sales_price_lists:manage",
	"sales_price_lists:read",
	"sales_system_diagrams:read",
	"salvos_commission_limits:manage",
	"salvos_commission_limits:read",
	"salvos_offer_commissions:calculate",
	"salvos_transport_activities:manage",
	"scheduled_jobs:run",
	"shop_order_batches:manage",
	"shop_order_batches:read",
	"shop_orders:manage",
	"shop_orders:manage_supplementary",
	"shop_orders:move_on_production_line",
	"shop_orders:pick",
	"shop_orders:read",
	"shop_orders:release",
	"shop_orders:report_production",
	"shop_orders:schedule",
	"shop_orders:set_production_line",
	"site_parts:manage",
	"site_parts:read",
	"spc_control_chart_collections:manage",
	"spc_control_chart_collections:read",
	"spc_control_charts:calculate_limits",
	"spc_control_charts:read",
	"spc_defect_events:read",
	"spc_defect_events:record",
	"spc_master_data:manage",
	"spc_master_data:read",
	"spc_measurements:manage",
	"spc_measurements:record",
	"spc_measurements:record_time",
	"spc_performance_charts:read",
	"spc_process_diagrams:read",
	"spc_process_improvements:manage",
	"spc_process_improvements:read",
	"spc_resources:set_state",
	"spc_summary_views:read",
	"spc_system_diagrams:read",
	"stock_counts:manage",
	"stock_counts:read",
	"subcontracting_operations:manage",
	"suppliers:manage",
	"suppliers:read",
	"survey_forms:manage",
	"survey_forms:read",
	"survey_submissions:audit",
	"survey_submissions:read",
	"survey_submissions:submit",
	"system_diagrams:manage",
	"task_templates:manage",
	"task_templates:read",
	"tasks:manage",
	"tasks:manage_all",
	"tasks:read",
	"tasks:read_all",
	"user_email:send",
	"user_groups:manage",
	"user_groups:read",
	"user_inbox:send_message",
	"users:manage",
	"users:read",
	"warehouse_locations:manage",
	"warehouse_locations:read",
	"warehouse_master_data:manage",
	"warehouse_master_data:read",
	"warehouse_transfers:manage",
	"warehouse_transfers:read",
	"wopi:access",
	"workspace_master_data:manage",
	"workspace_master_data:read",
	"workspaces:manage",
	"workspaces:read",
] as const;

export type Permission = (typeof PermissionValues)[number];

export const getPermissionLabels = () => ({
	"aavo_ai:use": t("permission_aavo_ai_use"),
	"aavo_ai:use_chat": t("permission_aavo_ai_use_chat"),
	"aavo_ai:web_access": t("permission_aavo_ai_web_access"),
	"accounting_master_data:manage": t("permission_accounting_master_data_manage"),
	"accounting_master_data:read": t("permission_accounting_master_data_read"),
	"ai_settings:manage": t("permission_ai_settings_manage"),
	"ai_usage:read": t("permission_ai_usage_read"),
	"api_connection_logs:read": t("permission_api_connection_logs_read"),
	"api_connections:manage": t("permission_api_connections_manage"),
	"api_connections:read": t("permission_api_connections_read"),
	"api_connections:use": t("permission_api_connections_use"),
	"api_keys:manage": t("permission_api_keys_manage"),
	"attribute_fields:manage": t("permission_attribute_fields_manage"),
	"attribute_fields:read": t("permission_attribute_fields_read"),
	"bi_dashboards:read": t("permission_bi_dashboards_read"),
	"catalog_parts:manage": t("permission_catalog_parts_manage"),
	"catalog_parts:read": t("permission_catalog_parts_read"),
	"common:basic_access": t("permission_common_basic_access"),
	"common_master_data:manage": t("permission_common_master_data_manage"),
	"common_master_data:read": t("permission_common_master_data_read"),
	"configurator_logs:read": t("permission_configurator_logs_read"),
	"configurators:manage": t("permission_configurators_manage"),
	"configurators:read": t("permission_configurators_read"),
	"configurators:test": t("permission_configurators_test"),
	"cost_event_master_data:manage": t("permission_cost_event_master_data_manage"),
	"cost_event_master_data:read": t("permission_cost_event_master_data_read"),
	"cost_events:manage": t("permission_cost_events_manage"),
	"cost_events:read": t("permission_cost_events_read"),
	"crm_master_data:manage": t("permission_crm_master_data_manage"),
	"crm_master_data:read": t("permission_crm_master_data_read"),
	"custom_apps:assign_execution_user": t("permission_custom_apps_assign_execution_user"),
	"custom_apps:create_organizational": t("permission_custom_apps_create_organizational"),
	"custom_apps:manage": t("permission_custom_apps_manage"),
	"custom_apps:manage_all": t("permission_custom_apps_manage_all"),
	"custom_apps:read": t("permission_custom_apps_read"),
	"custom_apps:read_sources": t("permission_custom_apps_read_sources"),
	"custom_apps:use": t("permission_custom_apps_use"),
	"custom_functions:assign_execution_user": t("permission_custom_functions_assign_execution_user"),
	"custom_functions:create_organizational": t("permission_custom_functions_create_organizational"),
	"custom_functions:execute": t("permission_custom_functions_execute"),
	"custom_functions:manage": t("permission_custom_functions_manage"),
	"custom_functions:manage_all": t("permission_custom_functions_manage_all"),
	"custom_functions:read": t("permission_custom_functions_read"),
	"custom_functions:test": t("permission_custom_functions_test"),
	"customer_offer_commissions:manage": t("permission_customer_offer_commissions_manage"),
	"customer_offer_commissions:read": t("permission_customer_offer_commissions_read"),
	"customer_offers:complete_signing": t("permission_customer_offers_complete_signing"),
	"customer_offers:manage": t("permission_customer_offers_manage"),
	"customer_offers:manage_all": t("permission_customer_offers_manage_all"),
	"customer_offers:manage_as_invoker": t("permission_customer_offers_manage_as_invoker"),
	"customer_offers:read": t("permission_customer_offers_read"),
	"customer_offers:read_all": t("permission_customer_offers_read_all"),
	"customer_offers:read_as_invoker": t("permission_customer_offers_read_as_invoker"),
	"customer_offers:read_costs": t("permission_customer_offers_read_costs"),
	"customer_order_commissions:manage": t("permission_customer_order_commissions_manage"),
	"customer_order_commissions:read": t("permission_customer_order_commissions_read"),
	"customer_orders:manage": t("permission_customer_orders_manage"),
	"customer_orders:pick": t("permission_customer_orders_pick"),
	"customer_orders:read": t("permission_customer_orders_read"),
	"customer_orders:read_info": t("permission_customer_orders_read_info"),
	"customers:manage": t("permission_customers_manage"),
	"customers:manage_all": t("permission_customers_manage_all"),
	"customers:manage_as_invoker": t("permission_customers_manage_as_invoker"),
	"customers:read": t("permission_customers_read"),
	"customers:read_all": t("permission_customers_read_all"),
	"customers:read_as_invoker": t("permission_customers_read_as_invoker"),
	"deliveries:load": t("permission_deliveries_load"),
	"deliveries:manage": t("permission_deliveries_manage"),
	"deliveries:read": t("permission_deliveries_read"),
	"delivery_master_data:manage": t("permission_delivery_master_data_manage"),
	"delivery_master_data:read": t("permission_delivery_master_data_read"),
	"delivery_packages:manage": t("permission_delivery_packages_manage"),
	"delivery_packages:read": t("permission_delivery_packages_read"),
	"delivery_packages:set_warehouse_location": t("permission_delivery_packages_set_warehouse_location"),
	"delivery_transports:drive": t("permission_delivery_transports_drive"),
	"delivery_transports:manage": t("permission_delivery_transports_manage"),
	"delivery_transports:plan": t("permission_delivery_transports_plan"),
	"delivery_transports:read": t("permission_delivery_transports_read"),
	"device_location:use": t("permission_device_location_use"),
	"diagnostics:read_sentry_events": t("permission_diagnostics_read_sentry_events"),
	"document_master_data:manage": t("permission_document_master_data_manage"),
	"document_master_data:read": t("permission_document_master_data_read"),
	"document_templates:manage": t("permission_document_templates_manage"),
	"document_templates:read": t("permission_document_templates_read"),
	"documents:delete": t("permission_documents_delete"),
	"documents:link_existing": t("permission_documents_link_existing"),
	"documents:manage": t("permission_documents_manage"),
	"documents:read": t("permission_documents_read"),
	"documents:send": t("permission_documents_send"),
	"email_log:read": t("permission_email_log_read"),
	"email_templates:manage": t("permission_email_templates_manage"),
	"email_templates:read": t("permission_email_templates_read"),
	"external_email:send": t("permission_external_email_send"),
	"google_maps:use": t("permission_google_maps_use"),
	"icons:search": t("permission_icons_search"),
	"integration_settings:manage": t("permission_integration_settings_manage"),
	"integration_settings:read": t("permission_integration_settings_read"),
	"inventory:manage": t("permission_inventory_manage"),
	"inventory:read": t("permission_inventory_read"),
	"invoices:manage": t("permission_invoices_manage"),
	"invoices:read": t("permission_invoices_read"),
	"manufacturing_system_diagrams:read": t("permission_manufacturing_system_diagrams_read"),
	"mellano_luukku_metrics:read": t("permission_mellano_luukku_metrics_read"),
	"mellano_luukku_planning:manage": t("permission_mellano_luukku_planning_manage"),
	"mellano_luukku_production:manage": t("permission_mellano_luukku_production_manage"),
	"mellano_luukku_production:read": t("permission_mellano_luukku_production_read"),
	"mellano_luukku_purchase_orders:import": t("permission_mellano_luukku_purchase_orders_import"),
	"mellano_luukku_purchase_suggestions:create": t("permission_mellano_luukku_purchase_suggestions_create"),
	"mellano_production_tools:use": t("permission_mellano_production_tools_use"),
	"mellano_winner_designs:manage": t("permission_mellano_winner_designs_manage"),
	"mellano_winner_designs:upload": t("permission_mellano_winner_designs_upload"),
	"notification_rules:manage": t("permission_notification_rules_manage"),
	"notification_rules:read": t("permission_notification_rules_read"),
	"object_change_log:read": t("permission_object_change_log_read"),
	"omegakeittiot_intra_orders:create": t("permission_omegakeittiot_intra_orders_create"),
	"part_configurations:configure": t("permission_part_configurations_configure"),
	"part_configurations:manage": t("permission_part_configurations_manage"),
	"part_configurations:read": t("permission_part_configurations_read"),
	"part_configurations:read_configurator": t("permission_part_configurations_read_configurator"),
	"part_master_data:manage": t("permission_part_master_data_manage"),
	"part_master_data:read": t("permission_part_master_data_read"),
	"part_warehouse_locations:read": t("permission_part_warehouse_locations_read"),
	"problem_report:send": t("permission_problem_report_send"),
	"product_change_master_data:manage": t("permission_product_change_master_data_manage"),
	"product_change_master_data:read": t("permission_product_change_master_data_read"),
	"product_change_requests:manage": t("permission_product_change_requests_manage"),
	"product_change_requests:manage_all": t("permission_product_change_requests_manage_all"),
	"product_change_requests:read": t("permission_product_change_requests_read"),
	"product_change_requests:read_all": t("permission_product_change_requests_read_all"),
	"product_changes:manage": t("permission_product_changes_manage"),
	"product_changes:read": t("permission_product_changes_read"),
	"production_master_data:manage": t("permission_production_master_data_manage"),
	"production_master_data:read": t("permission_production_master_data_read"),
	"production_reports:read": t("permission_production_reports_read"),
	"production_status:read": t("permission_production_status_read"),
	"project:activity_job_queue:external_user": t("permission_project_activity_job_queue_external_user"),
	"project_master_data:manage": t("permission_project_master_data_manage"),
	"project_master_data:read": t("permission_project_master_data_read"),
	"project_materials:manage": t("permission_project_materials_manage"),
	"project_materials:read": t("permission_project_materials_read"),
	"project_materials:release": t("permission_project_materials_release"),
	"projects:manage": t("permission_projects_manage"),
	"projects:pick": t("permission_projects_pick"),
	"projects:read": t("permission_projects_read"),
	"projects:report_progress": t("permission_projects_report_progress"),
	"projects:schedule_activities": t("permission_projects_schedule_activities"),
	"purchase_contracts:manage": t("permission_purchase_contracts_manage"),
	"purchase_contracts:read": t("permission_purchase_contracts_read"),
	"purchase_master_data:manage": t("permission_purchase_master_data_manage"),
	"purchase_master_data:read": t("permission_purchase_master_data_read"),
	"purchase_orders:manage": t("permission_purchase_orders_manage"),
	"purchase_orders:read": t("permission_purchase_orders_read"),
	"purchase_orders:receive": t("permission_purchase_orders_receive"),
	"purchase_orders:submit_supplier_documents": t("permission_purchase_orders_submit_supplier_documents"),
	"purchase_requests:manage": t("permission_purchase_requests_manage"),
	"purchase_requests:read": t("permission_purchase_requests_read"),
	"reclamation_master_data:manage": t("permission_reclamation_master_data_manage"),
	"reclamation_master_data:read": t("permission_reclamation_master_data_read"),
	"reclamations:manage": t("permission_reclamations_manage"),
	"reclamations:read": t("permission_reclamations_read"),
	"reclamations:report_progress": t("permission_reclamations_report_progress"),
	"replenishment_requests:manage": t("permission_replenishment_requests_manage"),
	"replenishment_requests:read": t("permission_replenishment_requests_read"),
	"route_optimization:use": t("permission_route_optimization_use"),
	"safety_control_master_data:manage": t("permission_safety_control_master_data_manage"),
	"safety_control_master_data:read": t("permission_safety_control_master_data_read"),
	"safety_control_surveys:manage": t("permission_safety_control_surveys_manage"),
	"safety_control_surveys:read": t("permission_safety_control_surveys_read"),
	"sales_activities:manage": t("permission_sales_activities_manage"),
	"sales_activities:manage_all": t("permission_sales_activities_manage_all"),
	"sales_activities:read": t("permission_sales_activities_read"),
	"sales_activities:read_all": t("permission_sales_activities_read_all"),
	"sales_commission_payments:manage": t("permission_sales_commission_payments_manage"),
	"sales_commission_payments:read": t("permission_sales_commission_payments_read"),
	"sales_contracts:manage": t("permission_sales_contracts_manage"),
	"sales_contracts:read": t("permission_sales_contracts_read"),
	"sales_leads:allocate": t("permission_sales_leads_allocate"),
	"sales_leads:manage": t("permission_sales_leads_manage"),
	"sales_leads:manage_all": t("permission_sales_leads_manage_all"),
	"sales_leads:read": t("permission_sales_leads_read"),
	"sales_leads:read_all": t("permission_sales_leads_read_all"),
	"sales_master_data:manage": t("permission_sales_master_data_manage"),
	"sales_master_data:read": t("permission_sales_master_data_read"),
	"sales_parts:manage": t("permission_sales_parts_manage"),
	"sales_parts:read": t("permission_sales_parts_read"),
	"sales_price_lists:manage": t("permission_sales_price_lists_manage"),
	"sales_price_lists:read": t("permission_sales_price_lists_read"),
	"sales_system_diagrams:read": t("permission_sales_system_diagrams_read"),
	"salvos_commission_limits:manage": t("permission_salvos_commission_limits_manage"),
	"salvos_commission_limits:read": t("permission_salvos_commission_limits_read"),
	"salvos_offer_commissions:calculate": t("permission_salvos_offer_commissions_calculate"),
	"salvos_transport_activities:manage": t("permission_salvos_transport_activities_manage"),
	"scheduled_jobs:run": t("permission_scheduled_jobs_run"),
	"shop_order_batches:manage": t("permission_shop_order_batches_manage"),
	"shop_order_batches:read": t("permission_shop_order_batches_read"),
	"shop_orders:manage": t("permission_shop_orders_manage"),
	"shop_orders:manage_supplementary": t("permission_shop_orders_manage_supplementary"),
	"shop_orders:move_on_production_line": t("permission_shop_orders_move_on_production_line"),
	"shop_orders:pick": t("permission_shop_orders_pick"),
	"shop_orders:read": t("permission_shop_orders_read"),
	"shop_orders:release": t("permission_shop_orders_release"),
	"shop_orders:report_production": t("permission_shop_orders_report_production"),
	"shop_orders:schedule": t("permission_shop_orders_schedule"),
	"shop_orders:set_production_line": t("permission_shop_orders_set_production_line"),
	"site_parts:manage": t("permission_site_parts_manage"),
	"site_parts:read": t("permission_site_parts_read"),
	"spc_control_chart_collections:manage": t("permission_spc_control_chart_collections_manage"),
	"spc_control_chart_collections:read": t("permission_spc_control_chart_collections_read"),
	"spc_control_charts:calculate_limits": t("permission_spc_control_charts_calculate_limits"),
	"spc_control_charts:read": t("permission_spc_control_charts_read"),
	"spc_defect_events:read": t("permission_spc_defect_events_read"),
	"spc_defect_events:record": t("permission_spc_defect_events_record"),
	"spc_master_data:manage": t("permission_spc_master_data_manage"),
	"spc_master_data:read": t("permission_spc_master_data_read"),
	"spc_measurements:manage": t("permission_spc_measurements_manage"),
	"spc_measurements:record": t("permission_spc_measurements_record"),
	"spc_measurements:record_time": t("permission_spc_measurements_record_time"),
	"spc_performance_charts:read": t("permission_spc_performance_charts_read"),
	"spc_process_diagrams:read": t("permission_spc_process_diagrams_read"),
	"spc_process_improvements:manage": t("permission_spc_process_improvements_manage"),
	"spc_process_improvements:read": t("permission_spc_process_improvements_read"),
	"spc_resources:set_state": t("permission_spc_resources_set_state"),
	"spc_summary_views:read": t("permission_spc_summary_views_read"),
	"spc_system_diagrams:read": t("permission_spc_system_diagrams_read"),
	"stock_counts:manage": t("permission_stock_counts_manage"),
	"stock_counts:read": t("permission_stock_counts_read"),
	"subcontracting_operations:manage": t("permission_subcontracting_operations_manage"),
	"suppliers:manage": t("permission_suppliers_manage"),
	"suppliers:read": t("permission_suppliers_read"),
	"survey_forms:manage": t("permission_survey_forms_manage"),
	"survey_forms:read": t("permission_survey_forms_read"),
	"survey_submissions:audit": t("permission_survey_submissions_audit"),
	"survey_submissions:read": t("permission_survey_submissions_read"),
	"survey_submissions:submit": t("permission_survey_submissions_submit"),
	"system_diagrams:manage": t("permission_system_diagrams_manage"),
	"task_templates:manage": t("permission_task_templates_manage"),
	"task_templates:read": t("permission_task_templates_read"),
	"tasks:manage": t("permission_tasks_manage"),
	"tasks:manage_all": t("permission_tasks_manage_all"),
	"tasks:read": t("permission_tasks_read"),
	"tasks:read_all": t("permission_tasks_read_all"),
	"user_email:send": t("permission_user_email_send"),
	"user_groups:manage": t("permission_user_groups_manage"),
	"user_groups:read": t("permission_user_groups_read"),
	"user_inbox:send_message": t("permission_user_inbox_send_message"),
	"users:manage": t("permission_users_manage"),
	"users:read": t("permission_users_read"),
	"warehouse_locations:manage": t("permission_warehouse_locations_manage"),
	"warehouse_locations:read": t("permission_warehouse_locations_read"),
	"warehouse_master_data:manage": t("permission_warehouse_master_data_manage"),
	"warehouse_master_data:read": t("permission_warehouse_master_data_read"),
	"warehouse_transfers:manage": t("permission_warehouse_transfers_manage"),
	"warehouse_transfers:read": t("permission_warehouse_transfers_read"),
	"wopi:access": t("permission_wopi_access"),
	"workspace_master_data:manage": t("permission_workspace_master_data_manage"),
	"workspace_master_data:read": t("permission_workspace_master_data_read"),
	"workspaces:manage": t("permission_workspaces_manage"),
	"workspaces:read": t("permission_workspaces_read"),
});

export const getPermissionLabel = (value: Permission): string => {
	return getPermissionLabels()[value];
};

export const isPermission = (value: string): value is Permission => {
	return (PermissionValues as readonly string[]).includes(value);
};
